import React from 'react'

const BidDataOverview = () => {
  return (
    <div>
      Nothing yet
      
    </div>
  )
}

export default BidDataOverview
